import { SkeletonNote } from "@dashboard/library";
import { useTranslation } from "react-i18next";

import { useCreateNote } from "@/hooks/useCreateNote/useCreateNote";
import { NotesList } from "../NotesList";
import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";
import { SectionNotesForm } from "../SectionNotesForm";

import { DisplayContentProps } from "./SectionNotes.decl";

import { useGetTagsAndNotes } from "@/hooks/useGetTagsAndNotes/useGetTagsAndNotes";
import { usePathParams } from "@/states/path_param";

function DisplayContent({ notes }: DisplayContentProps) {
  const { handleOnSubmit } = useCreateNote();

  if (!notes.length) {
    return <SectionNotesForm onSubmit={handleOnSubmit} show />;
  }

  return <NotesList notes={notes} />;
}

export function SectionNotes() {
  const { t } = useTranslation();
  const { callId } = usePathParams();

  const { notes, loading } = useGetTagsAndNotes({ callId });

  if (loading) {
    return <SkeletonNote />;
  }

  if (!notes) {
    return null;
  }

  return (
    <SectionLayout data-test="notes-section">
      <SectionHeader>{t("call_context.notes")}</SectionHeader>
      <DisplayContent notes={notes} />
    </SectionLayout>
  );
}
